export const CONFIGS_FETCH = 'configs/FETCH';
export const CONFIGS_DATA = 'configs/DATA';
export const CONFIGS_ERROR = 'configs/ERROR';
